module.exports = [
	"building",
	"culture",
	"information"
];


//////////////////
// WEBPACK FOOTER
// ./src/data/MARKER-TYPES.json
// module id = 318
// module chunks = 0